<template>
  <ul class="list-disc text-left">
    <li v-for="concern in concerns" :key="concern.id" class="mb-2">
      <span class="font-bold">{{ concern.concernTypeName }}:</span>
      <span> {{ concern.name }}</span>
      <br v-if="concern.concernRoleTitle" />
      <span v-if="concern.concernRoleTitle" class="italic"
        >{{ $t("components.people.profile.concerns_function") }}
        {{ concern.concernRoleTitle }}
      </span>
    </li>
  </ul>
</template>

<script>
export default {
  name: "Concerns",
  props: {
    concerns: {
      type: Array,
      required: true
    }
  }
};
</script>
